import { formatDistanceStrict } from 'date-fns';
import type { ReleasedSnapshot } from '../../../types/flow';
import { getVersionName } from './utils';

interface Props {
    snapshot: ReleasedSnapshot;
}

const ReleaseDate = ({ snapshot }: Props) => (
    <span
        className="quiet"
        title={`Snapshot Created: ${new Date(snapshot.dateCreated).toLocaleString(undefined, {
            dateStyle: 'medium',
            timeStyle: 'medium',
        })}`}
    >
        {getVersionName(snapshot)}{' '}
        {formatDistanceStrict(new Date(snapshot.dateCreated), Date.now(), {
            addSuffix: true,
        })}
    </span>
);

export default ReleaseDate;
